import { render, staticRenderFns } from "./candidateSurveyLoading.vue?vue&type=template&id=a08beb2c&"
import script from "./candidateSurveyLoading.vue?vue&type=script&lang=js&"
export * from "./candidateSurveyLoading.vue?vue&type=script&lang=js&"
import style0 from "./candidateSurveyLoading.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports